exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-ce795f2e],a[data-v-ce795f2e]:focus,a[data-v-ce795f2e]:hover{color:#2993ff}\n", ""]);

// exports
